// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"543d6ebb","231":"0f26a80d","239":"2cc3769c","453":"4f92c3ed","481":"e7bc6db6","668":"35fb6b8a","743":"42284a93","849":"99d0c7c6","885":"1ee2bbb5","922":"1d32d08e","948":"81e6628a"}[chunkId] + ".chunk.js";
};